module.exports = __webpack_public_path__ + "static/media/Web12802.b9951ea5.png";